<template>
  <transition name="fade-fast-transition" mode="out-in">
    <base-loading v-if="isLoading" :can-show-label="false" is-small key="loading"/>

    <span v-else key="icons">
      <font-awesome-icon v-if="isActive" :icon="['fas', 'star']" class="c-context-select__selection-favorite-star c-context-select__selection-favorite-star--is-active" @click.prevent="isLoading = true; $emit('remove-favorite', policy)"/>
      <font-awesome-icon v-else :icon="['fal', 'star']" class="c-context-select__selection-favorite-star" @click.prevent="isLoading = true; $emit('add-favorite', policy)"/>
    </span>
  </transition>
</template>

<script>
export default {
  name: 'FavoriteSelection',

  data () {
    return {
      isLoading: false
    }
  },

  props: {
    policy: {
      type: Object,
      required: true
    },
    favoriteItems: {
      type: Array,
      default: () => []
    }
  },

  mounted () {
    this.$watch(() => this.isActive, () => {
      if (this.isLoading) {
        this.isLoading = false
      }
    })
  },

  computed: {
    isActive () {
      const { merchantId, businessId } = this.policy

      return merchantId ? this.favoriteItems.some(item => item.merchantId === merchantId) : this.favoriteItems.some(item => item.businessId === businessId && typeof item.merchantId === 'undefined')
    }
  }
}
</script>
